module.exports = __webpack_public_path__ + "img/sg-214.prt.0c74d8e8.jpg";